import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useControl } from './useControl';
import { jsx as _jsx } from "react/jsx-runtime";
export * from './useControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    control,
    ControlPortal
  } = useControl(props);
  useImperativeHandle(ref, () => _extends({}, props, {
    control
  }), [control, props]);
  return /*#__PURE__*/_jsx(ControlPortal, {
    children: props.children
  });
});